<template>
  <section>

    <section
      id="devis">
      <v-parallax
        src="fond1_noblur.jpg"
        top
        height="380"
        class="gradienthero">
        <v-overlay
          :absolute="true"
        >
          <v-layout
            column
            align-center
            justify-center>
            <div class="display-2 font-weight-bold white--text mb-4 text-center text-uppercase">Demande de devis</div>
            <em>Votre demande de devis en 3 étapes</em>
          </v-layout>
        </v-overlay>
      </v-parallax>
    </section>

    <section>
      <v-container
        grid-list-xl>

        <v-container>

          <v-card
            v-show="loadingstatus"
            elevation="0"
            style="padding-top:1em; padding-bottom:1em; border-radius: 7px; border: 4px solid grey;">
            <v-card-title
              primary-title
              class="layout justify-center">
              <div class="headline text-center">
                <v-icon
                  x-large
                  color="secondary">mdi-upload</v-icon><br>
                Envoi de votre devis en cours...
              </div>
            </v-card-title>
          </v-card>

          <v-card
            v-show="validform"
            elevation="0"
            style="padding-top:1em; border-radius: 7px; border: 4px solid grey;">
            <v-card-title
              primary-title
              class="layout justify-center">
              <div class="headline text-center">
                <v-icon
                  x-large
                  color="secondary">mdi-check</v-icon><br>
                Votre demande de devis est transmise!
              </div>
            </v-card-title>
            <v-card-text
              class="text-center">
              <small>Vérifiez vos indésirables si vous ne recevez pas de courriel de confirmation.</small>
            </v-card-text>
          </v-card>

          <v-stepper
            v-show="!loadingstatus && !validform"
            v-model="e1">
            <v-card
              elevation="0"
              style="padding-top:1em;">
              <v-card-title
                primary-title
                class="layout justify-center">
                <div class="headline">Votre devis en 3 étapes</div>
              </v-card-title>
              <v-card-text
                class="layout justify-center">
                Obtenez un devis pratique rapide pour votre projet en 3 étapes:
              </v-card-text>
            </v-card>
            <v-stepper-header>
              <v-stepper-step
                :complete="e1 > 1"
                color="black"
                step="1">Projet</v-stepper-step>

              <v-divider/>

              <v-stepper-step
                :complete="e1 > 2"
                color="black"
                step="2">Contact</v-stepper-step>

              <v-divider/>

              <v-stepper-step
                color="black"
                step="3">Envoyer</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>

              <v-stepper-content step="1">
                <v-card
                  elevation="0"
                >
                  <v-layout
                    wrap>
                    <v-flex
                      xs12
                      md12>
                      <span>Votre demande devis pratique en 3 étapes.</span>
                      <p>Décrivez votre projet, même approximativement, pour que nous puissions évaluer votre devis.</p>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="newdevis.piece"
                        color="black"
                        label="Nombre de pièces"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="newdevis.surface"
                        color="black"
                        label="Surface totale (m2)"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="newdevis.angle"
                        color="black"
                        label="Nombre d’angles"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="newdevis.perimetre"
                        color="black"
                        label="Périmètre de la pièce"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="newdevis.couleur"
                        color="black"
                        label="Couleur"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md12>
                      <p>Message ou autre information à nous communiquer</p>
                      <v-textarea
                        v-model="newdevis.contenu"
                        color="black"/>
                    </v-flex>
                  </v-layout>

                </v-card>

                <v-btn
                  :disabled="!newdevis.piece || !newdevis.surface"
                  color="black"
                  @click="e1 = 2"
                >
                  Continuer
                </v-btn>
              </v-stepper-content>

              <v-stepper-content
                step="2">
                <v-card
                  elevation="0"
                >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      md12>
                      <p>Communiquez-nous quelques informations supplémentaires pour vous contacter et vous transmettre votre devis.</p>
                      <span><small>Vos informations personnelles seront utilisées uniquement pour répondre à votre demande.</small></span>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                    >
                      <v-text-field
                        v-model="newdevis.nom"
                        color="black"
                        label="Nom"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                    >
                      <v-text-field
                        v-model="newdevis.adresse"
                        color="black"
                        label="Adresse"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="newdevis.cp"
                        color="black"
                        label="Code postal"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="newdevis.ville"
                        color="black"
                        label="Ville"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="newdevis.mail"
                        color="black"
                        label="Courriel"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="newdevis.tel"
                        color="black"
                        label="Téléphone"
                      >
                        <template v-slot:append>
                          <span style="color:red;">*</span>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                    >
                      <span>Préférence de contact</span>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-checkbox
                        v-model="newdevis.selectcontactmail"
                        color="black"
                        label="Courriel"
                        style="padding-left: 1em;"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-checkbox
                        v-model="newdevis.selectcontacttel"
                        color="black"
                        label="Téléphone"
                        style="padding-left: 1em;"
                      />
                    </v-flex>
                  </v-layout>
                </v-card>

                <v-btn
                  color="black"
                  @click="e1 = 1"
                >
                  Retour
                </v-btn>

                <v-btn
                  :disabled="!newdevis.tel || !newdevis.mail || !newdevis.adresse || !newdevis.cp || !newdevis.ville || !newdevis.nom"
                  color="black"
                  @click="e1 = 3"
                >
                  Continuer
                </v-btn>

                <v-btn text>Cancel</v-btn>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-card-title>{{ newdevis.nom }}</v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        md12
                        style="margin-bottom:1em;"
                      >
                        <div class="text--primary">
                          Adresse
                        </div>
                        <v-flex
                          xs12
                          md12
                        >
                          {{ newdevis.adresse }}
                        </v-flex>
                        <v-flex
                          xs12
                          md12
                        >
                          {{ newdevis.cp }} {{ newdevis.ville }}
                        </v-flex>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                        style="margin-bottom:1em;"
                      >
                        <div class="text--primary">
                          Contacts
                        </div>
                        <v-flex
                          xs12
                          md6
                        >
                          <a :href="'mailto:'+newdevis.mail">{{ newdevis.mail }}</a>
                        </v-flex>
                        <v-flex
                          xs12
                          md6
                        >
                          <a :href="'tel:'+newdevis.tel">{{ newdevis.tel }}</a>
                        </v-flex>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                      >
                        <v-flex
                          xs12
                          md12
                        >
                          <div class="text--primary">
                            Préférence de contact
                          </div>
                        </v-flex>
                        <v-flex
                          v-if="newdevis.selectcontactmail"
                          xs12
                          md6
                        >
                          Courriel
                        </v-flex>
                        <v-flex
                          v-if="newdevis.selectcontacttel"
                          xs12
                          md6
                        >
                          Téléphone
                        </v-flex>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        style="margin-top:1em; margin-bottom:1em;"
                      >
                        <v-divider/>
                      </v-flex>
                      <v-flex
                        xs12
                        md4
                      >
                        <div class="text--primary">
                          Nombre de pièces
                        </div>
                        {{ newdevis.piece }}
                      </v-flex>
                      <v-flex
                        xs12
                        md4
                      >
                        <div class="text--primary">
                          Surface
                        </div>
                        {{ newdevis.surface }}m²
                      </v-flex>
                      <v-flex
                        xs12
                        md4
                      >
                        <div class="text--primary">
                          Nombre d’angles
                        </div>
                        {{ newdevis.angle }}
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                      >
                        <div class="text--primary">
                          Périmètre
                        </div>
                        {{ newdevis.perimetre }}m
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                      >
                        <div class="text--primary">
                          Couleur
                        </div>
                        {{ newdevis.couleur }}
                      </v-flex>
                      <v-flex
                        xs12
                        md12>
                        <span style="color:black;">Message ou autre information à nous communiquer</span>
                        <p v-html="newdevis.contenu"/>
                        <p v-if="!newdevis.contenu">Aucun message</p>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>

                <v-btn
                  color="primary"
                  @click="e1 = 1"
                >
                  Modifier
                </v-btn>

                <v-btn
                  color="black"
                  @click="notifyDevis()"
                >
                  Valider
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
      </v-container>
    </section>
  </section>
</template>

<script>
import { db } from '@/plugins/firebase'
import moment from 'moment'

export default {
  metaInfo () {
    return {
      title: 'Plafond et mur tendus NEWMAT Annecy'
    }
  },
  data () {
    return {
      loadingstatus: false,
      e1: 0,
      validform: false,
      newdevis: {
        publie: 'new',
        nom: '',
        adresse: '',
        cp: '',
        ville: '',
        mail: '',
        tel: '',
        selectcontactmail: false,
        selectcontacttel: false,
        piece: '',
        couleur: '',
        surface: '',
        angle: '',
        perimetre: '',
        contenu: ''
      }
    }
  },
  methods: {
    notifyDevis () {
      const $this = this
      this.loadingstatus = true
      const informations = this.newdevis
      informations.creation = moment().format('YYYY-MM-DD')
      db.collection('devis').add(informations)
        .then(function () {
          // eslint-disable-next-line
          Email.send({
            SecureToken: 'e9fac482-5d11-437e-a5c9-a36dd9a1353d',
            To: 'newmat.annecy@plafonds-tendus.fr',
            From: 'newmat.annecy@plafonds-tendus.fr',
            Subject: `NEWMAT - ${informations.nom} nouveau devis`,
            Body: `<!DOCTYPE html>
            <html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
            <head>
            <meta charset="utf-8"> <!-- utf-8 works for most cases -->
            <meta name="viewport" content="width=device-width"> <!-- Forcing initial-scale shouldn't be necessary -->
            <meta http-equiv="X-UA-Compatible" content="IE=edge"> <!-- Use the latest (edge) version of IE rendering engine -->
            <meta name="x-apple-disable-message-reformatting">  <!-- Disable auto-scale in iOS 10 Mail entirely -->
            <title></title> <!-- The title tag shows in email notifications, like Android 4.4. -->

            <link href="https://fonts.googleapis.com/css?family=Nunito+Sans:200,300,400,600,700" rel="stylesheet">

            <!-- CSS Reset : BEGIN -->
            <style>

            /* What it does: Remove spaces around the email design added by some email clients. */
            /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
            html,
            body {
            margin: 0 auto !important;
            padding: 0 !important;
            height: 100% !important;
            width: 100% !important;
            background: #f1f1f1;
            }

            /* What it does: Stops email clients resizing small text. */
            * {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
            }

            /* What it does: Centers email on Android 4.4 */
            div[style*="margin: 16px 0"] {
            margin: 0 !important;
            }

            /* What it does: Stops Outlook from adding extra spacing to tables. */
            table,
            td {
            mso-table-lspace: 0pt !important;
            mso-table-rspace: 0pt !important;
            }

            /* What it does: Fixes webkit padding issue. */
            table {
            border-spacing: 0 !important;
            border-collapse: collapse !important;
            table-layout: fixed !important;
            margin: 0 auto !important;
            }

            /* What it does: Uses a better rendering method when resizing images in IE. */
            img {
            -ms-interpolation-mode:bicubic;
            }

            /* What it does: Prevents Windows 10 Mail from underlining links despite inline CSS. Styles for underlined links should be inline. */
            a {
            text-decoration: none;
            }

            /* What it does: A work-around for email clients meddling in triggered links. */
            *[x-apple-data-detectors],  /* iOS */
            .unstyle-auto-detected-links *,
            .aBn {
            border-bottom: 0 !important;
            cursor: default !important;
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
            }

            /* What it does: Prevents Gmail from displaying a download button on large, non-linked images. */
            .a6S {
            display: none !important;
            opacity: 0.01 !important;
            }

            /* What it does: Prevents Gmail from changing the text color in conversation threads. */
            .im {
            color: inherit !important;
            }

            /* If the above doesn't work, add a .g-img class to any image in question. */
            img.g-img + div {
            display: none !important;
            }

            /* What it does: Removes right gutter in Gmail iOS app: https://github.com/TedGoas/Cerberus/issues/89  */
            /* Create one of these media queries for each additional viewport size you'd like to fix */

            /* iPhone 4, 4S, 5, 5S, 5C, and 5SE */
            @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {
            u ~ div .email-container {
            min-width: 320px !important;
            }
            }
            /* iPhone 6, 6S, 7, 8, and X */
            @media only screen and (min-device-width: 375px) and (max-device-width: 413px) {
            u ~ div .email-container {
            min-width: 375px !important;
            }
            }
            /* iPhone 6+, 7+, and 8+ */
            @media only screen and (min-device-width: 414px) {
            u ~ div .email-container {
            min-width: 414px !important;
            }
            }

            </style>

            <!-- CSS Reset : END -->

            <!-- Progressive Enhancements : BEGIN -->
            <style>
            .primary{
            background: #6aaaff;
            }
            .bg_white{
            background: #ffffff;
            }
            .bg_light{
            background: #fafafa;
            }
            .bg_black{
            background: #000000;
            }
            .bg_dark{
            background: rgba(0,0,0,.8);
            }
            .email-section{
            padding:2.5em;
            }

            /*BUTTON*/
            .btn{
            padding: 5px 15px;
            display: inline-block;
            }
            .btn.btn-primary{
            border-radius: 5px;
            background: #6aaaff;
            color: #000;
            }
            .btn.btn-white{
            border-radius: 5px;
            background: #ffffff;
            color: #000000;
            }
            .btn.btn-white-outline{
            border-radius: 5px;
            background: transparent;
            border: 1px solid #fff;
            color: #fff;
            }
            .btn.btn-black{
            border-radius: 5px;
            background: #000;
            color: #fff;
            }

            h1,h2,h3,h4,h5,h6{
            font-family: 'Nunito Sans', sans-serif;
            color: #000000;
            margin-top: 0;
            }

            body{
            font-family: 'Nunito Sans', sans-serif;
            font-weight: 400;
            font-size: 15px;
            line-height: 1.8;
            color: rgba(0,0,0,.4);
            }

            a{
            color: #6aaaff;
            }

            table{
            }
            /*LOGO*/

            .logo h1{
            margin: 0;
            }
            .logo h1 a{
            color: #000000;
            font-size: 20px;
            font-weight: 700;
            font-family: 'Nunito Sans', sans-serif;
            }

            .navigation{
            padding: 0;
            }
            .navigation li{
            list-style: none;
            display: inline-block;;
            margin-left: 5px;
            font-size: 13px;
            font-weight: 500;
            }
            .navigation li a{
            color: rgba(0,0,0,.4);
            }

            /*HERO*/
            .hero{
            position: relative;
            z-index: 0;
            }
            .hero .overlay{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            content: '';
            width: 100%;
            background: #000000;
            z-index: -1;
            opacity: .3;
            }
            .hero .icon{
            }
            .hero .icon a{
            display: block;
            width: 60px;
            margin: 0 auto;
            }
            .hero .text{
            color: rgba(0,0,0,.8);
            }
            .hero .text h2{
            color: #000;
            font-size: 32px;
            margin-bottom: 0;
            font-weight: 200;
            line-height: 1.4;
            }

            /*HEADING SECTION*/
            .heading-section{
            }
            .heading-section h2{
            color: #000000;
            font-size: 28px;
            margin-top: 0;
            line-height: 1.4;
            font-weight: 400;
            }
            .heading-section .subheading{
            margin-bottom: 20px !important;
            display: inline-block;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: rgba(0,0,0,.4);
            position: relative;
            }
            .heading-section .subheading::after{
            position: absolute;
            left: 0;
            right: 0;
            bottom: -10px;
            content: '';
            width: 100%;
            height: 2px;
            background: #6aaaff;
            margin: 0 auto;
            }

            .heading-section-white{
            color: rgba(255,255,255,.8);
            }
            .heading-section-white h2{
            font-family:
            line-height: 1;
            padding-bottom: 0;
            }
            .heading-section-white h2{
            color: #ffffff;
            }
            .heading-section-white .subheading{
            margin-bottom: 0;
            display: inline-block;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: rgba(255,255,255,.4);
            }

            .icon{
            text-align: center;
            }
            .icon img{
            }

            /*SERVICES*/
            .services{
            }
            .text-services{
            padding: 10px 10px 0;
            text-align: center;
            }
            .text-services h3{
            font-size: 18px;
            font-weight: 400;
            }

            .services-list{
            padding: 0;
            margin: 0 0 20px 0;
            width: 100%;
            float: left;
            }

            .services-list img{
            float: left;
            }
            .services-list .text{
            width: calc(100% - 60px);
            float: right;
            }
            .services-list h3{
            margin-top: 0;
            margin-bottom: 0;
            }
            .services-list p{
            margin: 0;
            }

            /*PROJECT*/
            .project-entry{
            position: relative;
            }
            .text-project{
            padding-top: 10px;
            position: absolute;
            bottom: 10px;
            left: 0;
            right: 0;
            }
            .text-project h3{
            margin-bottom: 0;
            font-size: 16px;
            font-weight: 600;
            }
            .text-project h3 a{
            color: #fff;
            }
            .text-project span{
            font-size: 13px;
            color: rgba(255,255,255,.8);
            }

            /*PRICING*/
            .pricing{
            position: relative;
            text-align: center;
            border: 1px solid rgba(0,0,0,.05);
            border: 1px solid #6aaaff;
            padding: 2em 1em;
            /*rgba(0,0,0,.05;)*/
            }
            .pricing h3{
            font-weight: 400;
            margin-bottom: 10px;
            }
            .pricing h2{
            font-size: 50px;
            font-weight: 400;
            margin-bottom: 0;
            margin-top: 0;
            line-height: 1.4;
            }
            .pricing .start{
            padding: 0;
            font-weight: 600;
            margin-bottom: 0;
            }
            .pricing h2 span{
            }
            .pricing h2 small{
            font-size: 18px;
            }
            .pricing ul{
            padding: 0;
            margin: 20px 0 0 0;
            }
            .pricing ul li{
            list-style: none;
            margin-bottom: 10px;
            }

            /*BLOG*/
            .text-services .meta{
            text-transform: uppercase;
            font-size: 14px;
            margin-top: 0;
            }
            .text-services h3{
            margin-top: 0;
            line-height: 1.2;
            font-size: 20px;
            }

            /*TESTIMONY*/
            .text-testimony .name{
            margin: 0;
            }
            .text-testimony .position{
            color: rgba(0,0,0,.3);

            }

            /*VIDEO*/
            .img{
            width: 100%;
            height: auto;
            position: relative;
            }
            .img .icon{
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            bottom: 0;
            margin-top: -25px;
            }
            .img .icon a{
            display: block;
            width: 60px;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -25px;
            }

            /*COUNTER*/
            .counter{
            width: 100%;
            position: relative;
            z-index: 0;
            }
            .counter .overlay{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            content: '';
            width: 100%;
            background: #000000;
            z-index: -1;
            opacity: .3;
            }
            .counter-text{
            text-align: center;
            }
            .counter-text .num{
            display: block;
            color: #000;
            font-size: 34px;
            font-weight: 400;
            }
            .counter-text .name{
            display: block;
            color: rgba(0,0,0,.9);
            font-size: 14px;
            }

            ul.social{
            padding: 20px 0 0 0;
            }
            ul.social li{
            display: inline-block;
            margin-right: 10px;
            }
            /*FOOTER*/

            .footer{
            color: rgba(255,255,255,.5);

            }
            .footer .heading{
            color: #ffffff;
            font-size: 20px;
            }
            .footer ul{
            margin: 0;
            padding: 0;
            }
            .footer ul li{
            list-style: none;
            margin-bottom: 10px;
            }
            .footer ul li a{
            color: rgba(255,255,255,1);
            }

            @media screen and (max-width: 500px) {

            .icon{
            text-align: left;
            }

            .text-services{
            padding-left: 0;
            padding-right: 20px;
            text-align: left;
            }

            }

            </style>

            </head>

            <body width="100%" style="margin: 0; padding: 0 !important; mso-line-height-rule: exactly; background-color: #222222;">
            <center style="width: 100%; background-color: #f1f1f1;">
            <div style="display: none; font-size: 1px;max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; mso-hide: all; font-family: sans-serif;">
            &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
            </div>
            <div style="max-width: 600px; margin: 0 auto;" class="email-container">
            <!-- BEGIN BODY -->
            <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
            <tr>
            <td valign="top" class="bg_white" style="padding: 1em 2.5em;">
            <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr>
            <td width="40%" class="logo" style="text-align: left;">
            <h1><a target="_blank" href="https://www.plafonds-tendus.fr"><img src="https://silly-knuth-78d909.netlify.com/logo_newmat.svg"></a></h1>
            </td>
            <td width="60%" class="logo" style="text-align: right;">
            <ul class="navigation">
            <li><a target="_blank" href="https://www.plafonds-tendus.fr">www.plafonds-tendus.fr</a></li>
            </ul>
            </td>
            </tr>
            </table>
            </td>
            </tr><!-- end tr -->
            <tr>
            <td valign="middle" class="hero bg_white">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
            <td valign="middle" width="50%">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
            <td>
            <img src="https://silly-knuth-78d909.netlify.com/images/bg_1.jpg" alt="" style="width: 100%; max-width: 600px; height: auto; margin: auto; display: block;">
            </td>
            </tr>
            </table>
            </td>
            <td valign="middle" width="50%" class="primary">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
            <td class="text" style="text-align: left; padding: 20px 30px;">
            <h2>Votre devis est en étude</h2>
            <p>Merci de nous avoir transmis votre demande de devis, nous vous recontacterons dans les plus brefs délais.</p>
            </td>
            </tr>
            </table>
            </td>
            </tr>
            </table>
            </td>
            </tr><!-- end tr -->
            <tr>
            <td class="bg_white">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
            <td class="bg_white email-section">
            <div class="heading-section" style="text-align: center; padding: 0 30px;">
            <h2>Demande de devis</h2>
            <p>Voici le résumé de votre demande de devis:</p>
            </div>
            <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr>
            <td valign="top" width="100%" style="padding-top: 20px;" class="services">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
            <td class="text-services">
            <h5>Informations</h5>
            <p>${informations.nom}</p>
            <p>${informations.adresse} ${informations.cp} ${informations.ville}</p>
            </td>
            <td class="text-services">
            <h5>Contact</h5>
            <p>${informations.mail}</p>
            <p>${informations.tel}</p>
            </td>
            </tr>
            </table>
            </td>
            </tr>
            <tr>
            <td valign="top" width="100%" style="padding-top: 20px;" class="services">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
            <td class="text-services">
            <h5>Nb pièces</h5>
            <p>${informations.piece}</p>
            </td>
            <td class="text-services">
            <h5>Surface</h5>
            <p>${informations.surface}m2</p>
            </td>
            <td class="text-services">
            <h5>Nb angles</h5>
            <p>${informations.angle}</p>
            </td>
            <td class="text-services">
            <h5>Périmètre</h5>
            <p>${informations.perimetre}m</p>
            </td>
            <td class="text-services">
            <h5>Couleur</h5>
            <p>${informations.couleur}</p>
            </td>
            </tr>
            </table>
            </td>
            </tr>
            <tr>
            <td class="text-services">
            <h5>Message</h5>
            <p>${informations.contenu}</p>
            </td>
            </tr>
            </table>
            </td>
            </tr><!-- end: tr -->
            </table>

            </td>
            </tr><!-- end:tr -->
            <!-- 1 Column Text + Button : END -->
            </table>
            <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
            <tr>
            <td valign="middle" class="bg_black footer email-section">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
            <tr>
            <td width="100%" style="text-align: center;">
            <p style="font-size: 22px; margin-top: 0;"><a target="_blank" href="https://www.plafonds-tendus.fr"><img style="width:150px;" src="https://silly-knuth-78d909.netlify.com/logo_newmat_white_white.svg"></a></p>
            </td>
            </tr>
            <tr>
            <td width="100%" style="text-align: center;">
            <p style="margin-top: 0;">www.plafonds-tendus.fr</p>
            </td>
            </tr>
            <tr>
            <td width="100%" style="text-align: center;">
            <ul class="social">
            <li><a target="_blank" href="https://www.plafonds-tendus.fr"><img src="https://silly-knuth-78d909.netlify.com/images/004-website-logo.png" alt="" style="width: 24px; max-width: 600px; height: auto; display: block;"></a></li>
            <li><a target="_blank" href="https://www.facebook.com/Eyraud.Yves.Crea.Lucas"><img src="https://silly-knuth-78d909.netlify.com/images/005-facebook.png" alt="" style="width: 24px; max-width: 600px; height: auto; display: block;"></a></li>
            </ul>
            </td>
            </tr>
            </table>
            </td>
            </tr>
            </table>
            </div>
            </center>
            </body>
            </html>`
          }).then(function () {
            // eslint-disable-next-line
            Email.send({
              SecureToken: 'e9fac482-5d11-437e-a5c9-a36dd9a1353d',
              To: [informations.mail],
              From: 'newmat.annecy@plafonds-tendus.fr',
              Subject: `NEWMAT - ${informations.nom} nouveau devis`,
              Body: `<!DOCTYPE html>
              <html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
              <head>
              <meta charset="utf-8"> <!-- utf-8 works for most cases -->
              <meta name="viewport" content="width=device-width"> <!-- Forcing initial-scale shouldn't be necessary -->
              <meta http-equiv="X-UA-Compatible" content="IE=edge"> <!-- Use the latest (edge) version of IE rendering engine -->
              <meta name="x-apple-disable-message-reformatting">  <!-- Disable auto-scale in iOS 10 Mail entirely -->
              <title></title> <!-- The title tag shows in email notifications, like Android 4.4. -->

              <link href="https://fonts.googleapis.com/css?family=Nunito+Sans:200,300,400,600,700" rel="stylesheet">

              <!-- CSS Reset : BEGIN -->
              <style>

              /* What it does: Remove spaces around the email design added by some email clients. */
              /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
              html,
              body {
              margin: 0 auto !important;
              padding: 0 !important;
              height: 100% !important;
              width: 100% !important;
              background: #f1f1f1;
              }

              /* What it does: Stops email clients resizing small text. */
              * {
              -ms-text-size-adjust: 100%;
              -webkit-text-size-adjust: 100%;
              }

              /* What it does: Centers email on Android 4.4 */
              div[style*="margin: 16px 0"] {
              margin: 0 !important;
              }

              /* What it does: Stops Outlook from adding extra spacing to tables. */
              table,
              td {
              mso-table-lspace: 0pt !important;
              mso-table-rspace: 0pt !important;
              }

              /* What it does: Fixes webkit padding issue. */
              table {
              border-spacing: 0 !important;
              border-collapse: collapse !important;
              table-layout: fixed !important;
              margin: 0 auto !important;
              }

              /* What it does: Uses a better rendering method when resizing images in IE. */
              img {
              -ms-interpolation-mode:bicubic;
              }

              /* What it does: Prevents Windows 10 Mail from underlining links despite inline CSS. Styles for underlined links should be inline. */
              a {
              text-decoration: none;
              }

              /* What it does: A work-around for email clients meddling in triggered links. */
              *[x-apple-data-detectors],  /* iOS */
              .unstyle-auto-detected-links *,
              .aBn {
              border-bottom: 0 !important;
              cursor: default !important;
              color: inherit !important;
              text-decoration: none !important;
              font-size: inherit !important;
              font-family: inherit !important;
              font-weight: inherit !important;
              line-height: inherit !important;
              }

              /* What it does: Prevents Gmail from displaying a download button on large, non-linked images. */
              .a6S {
              display: none !important;
              opacity: 0.01 !important;
              }

              /* What it does: Prevents Gmail from changing the text color in conversation threads. */
              .im {
              color: inherit !important;
              }

              /* If the above doesn't work, add a .g-img class to any image in question. */
              img.g-img + div {
              display: none !important;
              }

              /* What it does: Removes right gutter in Gmail iOS app: https://github.com/TedGoas/Cerberus/issues/89  */
              /* Create one of these media queries for each additional viewport size you'd like to fix */

              /* iPhone 4, 4S, 5, 5S, 5C, and 5SE */
              @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {
              u ~ div .email-container {
              min-width: 320px !important;
              }
              }
              /* iPhone 6, 6S, 7, 8, and X */
              @media only screen and (min-device-width: 375px) and (max-device-width: 413px) {
              u ~ div .email-container {
              min-width: 375px !important;
              }
              }
              /* iPhone 6+, 7+, and 8+ */
              @media only screen and (min-device-width: 414px) {
              u ~ div .email-container {
              min-width: 414px !important;
              }
              }


              </style>

              <!-- CSS Reset : END -->

              <!-- Progressive Enhancements : BEGIN -->
              <style>

              .primary{
              background: #6aaaff;
              }
              .bg_white{
              background: #ffffff;
              }
              .bg_light{
              background: #fafafa;
              }
              .bg_black{
              background: #000000;
              }
              .bg_dark{
              background: rgba(0,0,0,.8);
              }
              .email-section{
              padding:2.5em;
              }

              /*BUTTON*/
              .btn{
              padding: 5px 15px;
              display: inline-block;
              }
              .btn.btn-primary{
              border-radius: 5px;
              background: #6aaaff;
              color: #000;
              }
              .btn.btn-white{
              border-radius: 5px;
              background: #ffffff;
              color: #000000;
              }
              .btn.btn-white-outline{
              border-radius: 5px;
              background: transparent;
              border: 1px solid #fff;
              color: #fff;
              }
              .btn.btn-black{
              border-radius: 5px;
              background: #000;
              color: #fff;
              }

              h1,h2,h3,h4,h5,h6{
              font-family: 'Nunito Sans', sans-serif;
              color: #000000;
              margin-top: 0;
              }

              body{
              font-family: 'Nunito Sans', sans-serif;
              font-weight: 400;
              font-size: 15px;
              line-height: 1.8;
              color: rgba(0,0,0,.4);
              }

              a{
              color: #6aaaff;
              }

              table{
              }
              /*LOGO*/

              .logo h1{
              margin: 0;
              }
              .logo h1 a{
              color: #000000;
              font-size: 20px;
              font-weight: 700;
              font-family: 'Nunito Sans', sans-serif;
              }

              .navigation{
              padding: 0;
              }
              .navigation li{
              list-style: none;
              display: inline-block;;
              margin-left: 5px;
              font-size: 13px;
              font-weight: 500;
              }
              .navigation li a{
              color: rgba(0,0,0,.4);
              }

              /*HERO*/
              .hero{
              position: relative;
              z-index: 0;
              }
              .hero .overlay{
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              content: '';
              width: 100%;
              background: #000000;
              z-index: -1;
              opacity: .3;
              }
              .hero .icon{
              }
              .hero .icon a{
              display: block;
              width: 60px;
              margin: 0 auto;
              }
              .hero .text{
              color: rgba(0,0,0,.8);
              }
              .hero .text h2{
              color: #000;
              font-size: 32px;
              margin-bottom: 0;
              font-weight: 200;
              line-height: 1.4;
              }


              /*HEADING SECTION*/
              .heading-section{
              }
              .heading-section h2{
              color: #000000;
              font-size: 28px;
              margin-top: 0;
              line-height: 1.4;
              font-weight: 400;
              }
              .heading-section .subheading{
              margin-bottom: 20px !important;
              display: inline-block;
              font-size: 13px;
              text-transform: uppercase;
              letter-spacing: 2px;
              color: rgba(0,0,0,.4);
              position: relative;
              }
              .heading-section .subheading::after{
              position: absolute;
              left: 0;
              right: 0;
              bottom: -10px;
              content: '';
              width: 100%;
              height: 2px;
              background: #6aaaff;
              margin: 0 auto;
              }

              .heading-section-white{
              color: rgba(255,255,255,.8);
              }
              .heading-section-white h2{
              font-family:
              line-height: 1;
              padding-bottom: 0;
              }
              .heading-section-white h2{
              color: #ffffff;
              }
              .heading-section-white .subheading{
              margin-bottom: 0;
              display: inline-block;
              font-size: 13px;
              text-transform: uppercase;
              letter-spacing: 2px;
              color: rgba(255,255,255,.4);
              }


              .icon{
              text-align: center;
              }
              .icon img{
              }


              /*SERVICES*/
              .services{
              }
              .text-services{
              padding: 10px 10px 0;
              text-align: center;
              }
              .text-services h3{
              font-size: 18px;
              font-weight: 400;
              }

              .services-list{
              padding: 0;
              margin: 0 0 20px 0;
              width: 100%;
              float: left;
              }

              .services-list img{
              float: left;
              }
              .services-list .text{
              width: calc(100% - 60px);
              float: right;
              }
              .services-list h3{
              margin-top: 0;
              margin-bottom: 0;
              }
              .services-list p{
              margin: 0;
              }

              /*PROJECT*/
              .project-entry{
              position: relative;
              }
              .text-project{
              padding-top: 10px;
              position: absolute;
              bottom: 10px;
              left: 0;
              right: 0;
              }
              .text-project h3{
              margin-bottom: 0;
              font-size: 16px;
              font-weight: 600;
              }
              .text-project h3 a{
              color: #fff;
              }
              .text-project span{
              font-size: 13px;
              color: rgba(255,255,255,.8);
              }

              /*PRICING*/
              .pricing{
              position: relative;
              text-align: center;
              border: 1px solid rgba(0,0,0,.05);
              border: 1px solid #6aaaff;
              padding: 2em 1em;
              /*rgba(0,0,0,.05;)*/
              }
              .pricing h3{
              font-weight: 400;
              margin-bottom: 10px;
              }
              .pricing h2{
              font-size: 50px;
              font-weight: 400;
              margin-bottom: 0;
              margin-top: 0;
              line-height: 1.4;
              }
              .pricing .start{
              padding: 0;
              font-weight: 600;
              margin-bottom: 0;
              }
              .pricing h2 span{
              }
              .pricing h2 small{
              font-size: 18px;
              }
              .pricing ul{
              padding: 0;
              margin: 20px 0 0 0;
              }
              .pricing ul li{
              list-style: none;
              margin-bottom: 10px;
              }

              /*BLOG*/
              .text-services .meta{
              text-transform: uppercase;
              font-size: 14px;
              margin-top: 0;
              }
              .text-services h3{
              margin-top: 0;
              line-height: 1.2;
              font-size: 20px;
              }

              /*TESTIMONY*/
              .text-testimony .name{
              margin: 0;
              }
              .text-testimony .position{
              color: rgba(0,0,0,.3);

              }


              /*VIDEO*/
              .img{
              width: 100%;
              height: auto;
              position: relative;
              }
              .img .icon{
              position: absolute;
              top: 50%;
              left: 0;
              right: 0;
              bottom: 0;
              margin-top: -25px;
              }
              .img .icon a{
              display: block;
              width: 60px;
              position: absolute;
              top: 0;
              left: 50%;
              margin-left: -25px;
              }



              /*COUNTER*/
              .counter{
              width: 100%;
              position: relative;
              z-index: 0;
              }
              .counter .overlay{
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              content: '';
              width: 100%;
              background: #000000;
              z-index: -1;
              opacity: .3;
              }
              .counter-text{
              text-align: center;
              }
              .counter-text .num{
              display: block;
              color: #000;
              font-size: 34px;
              font-weight: 400;
              }
              .counter-text .name{
              display: block;
              color: rgba(0,0,0,.9);
              font-size: 14px;
              }



              ul.social{
              padding: 20px 0 0 0;
              }
              ul.social li{
              display: inline-block;
              margin-right: 10px;
              }
              /*FOOTER*/

              .footer{
              color: rgba(255,255,255,.5);

              }
              .footer .heading{
              color: #ffffff;
              font-size: 20px;
              }
              .footer ul{
              margin: 0;
              padding: 0;
              }
              .footer ul li{
              list-style: none;
              margin-bottom: 10px;
              }
              .footer ul li a{
              color: rgba(255,255,255,1);
              }


              @media screen and (max-width: 500px) {

              .icon{
              text-align: left;
              }

              .text-services{
              padding-left: 0;
              padding-right: 20px;
              text-align: left;
              }

              }


              </style>


              </head>

              <body width="100%" style="margin: 0; padding: 0 !important; mso-line-height-rule: exactly; background-color: #222222;">
              <center style="width: 100%; background-color: #f1f1f1;">
              <div style="display: none; font-size: 1px;max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; mso-hide: all; font-family: sans-serif;">
              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
              </div>
              <div style="max-width: 600px; margin: 0 auto;" class="email-container">
              <!-- BEGIN BODY -->
              <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
              <tr>
              <td valign="top" class="bg_white" style="padding: 1em 2.5em;">
              <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
              <tr>
              <td width="40%" class="logo" style="text-align: left;">
              <h1><a target="_blank" href="https://www.plafonds-tendus.fr"><img src="https://silly-knuth-78d909.netlify.com/logo_newmat.svg"></a></h1>
              </td>
              <td width="60%" class="logo" style="text-align: right;">
              <ul class="navigation">
              <li><a target="_blank" href="https://www.plafonds-tendus.fr">www.plafonds-tendus.fr</a></li>
              </ul>
              </td>
              </tr>
              </table>
              </td>
              </tr><!-- end tr -->
              <tr>
              <td valign="middle" class="hero bg_white">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
              <tr>
              <td valign="middle" width="50%">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
              <tr>
              <td>
              <img src="https://silly-knuth-78d909.netlify.com/images/bg_1.jpg" alt="" style="width: 100%; max-width: 600px; height: auto; margin: auto; display: block;">
              </td>
              </tr>
              </table>
              </td>
              <td valign="middle" width="50%" class="primary">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
              <tr>
              <td class="text" style="text-align: left; padding: 20px 30px;">
              <h2>Votre devis est en étude</h2>
              <p>Merci de nous avoir transmis votre demande de devis, nous vous recontacterons dans les plus brefs délais.</p>
              </td>
              </tr>
              </table>
              </td>
              </tr>
              </table>
              </td>
              </tr><!-- end tr -->
              <tr>
              <td class="bg_white">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
              <tr>
              <td class="bg_white email-section">
              <div class="heading-section" style="text-align: center; padding: 0 30px;">
              <h2>Demande de devis</h2>
              <p>Voici le résumé de votre demande de devis:</p>
              </div>
              <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
              <tr>
              <td valign="top" width="100%" style="padding-top: 20px;" class="services">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
              <tr>
              <td class="text-services">
              <h5>Informations</h5>
              <p>${informations.nom}</p>
              <p>${informations.adresse} ${informations.cp} ${informations.ville}</p>
              </td>
              <td class="text-services">
              <h5>Contact</h5>
              <p>${informations.mail}</p>
              <p>${informations.tel}</p>
              </td>
              </tr>
              </table>
              </td>
              </tr>
              <tr>
              <td valign="top" width="100%" style="padding-top: 20px;" class="services">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
              <tr>
              <td class="text-services">
              <h5>Nb pièces</h5>
              <p>${informations.piece}</p>
              </td>
              <td class="text-services">
              <h5>Surface</h5>
              <p>${informations.surface}m2</p>
              </td>
              <td class="text-services">
              <h5>Nb angles</h5>
              <p>${informations.angle}</p>
              </td>
              <td class="text-services">
              <h5>Périmètre</h5>
              <p>${informations.perimetre}m</p>
              </td>
              <td class="text-services">
              <h5>Couleur</h5>
              <p>${informations.couleur}</p>
              </td>
              </tr>
              </table>
              </td>
              </tr>
              <tr>
              <td class="text-services">
              <h5>Message</h5>
              <p>${informations.contenu}</p>
              </td>
              </tr>
              </table>
              </td>
              </tr><!-- end: tr -->
              </table>

              </td>
              </tr><!-- end:tr -->
              <!-- 1 Column Text + Button : END -->
              </table>
              <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
              <tr>
              <td valign="middle" class="bg_black footer email-section">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
              <tr>
              <td width="100%" style="text-align: center;">
              <p style="font-size: 22px; margin-top: 0;"><a target="_blank" href="https://www.plafonds-tendus.fr"><img style="width:150px;" src="https://silly-knuth-78d909.netlify.com/logo_newmat_white_white.svg"></a></p>
              </td>
              </tr>
              <tr>
              <td width="100%" style="text-align: center;">
              <p style="margin-top: 0;">www.plafonds-tendus.fr</p>
              </td>
              </tr>
              <tr>
              <td width="100%" style="text-align: center;">
              <ul class="social">
              <li><a target="_blank" href="https://www.plafonds-tendus.fr"><img src="https://silly-knuth-78d909.netlify.com/images/004-website-logo.png" alt="" style="width: 24px; max-width: 600px; height: auto; display: block;"></a></li>
              <li><a target="_blank" href="https://www.facebook.com/Eyraud.Yves.Crea.Lucas"><img src="https://silly-knuth-78d909.netlify.com/images/005-facebook.png" alt="" style="width: 24px; max-width: 600px; height: auto; display: block;"></a></li>
              </ul>
              </td>
              </tr>
              </table>
              </td>
              </tr>
              </table>
              </div>
              </center>
              </body>
              </html>`
            }).then(function () {
              $this.newdevis = {
                publie: false,
                nom: '',
                adresse: '',
                cp: '',
                ville: '',
                mail: '',
                tel: '',
                selectcontactmail: false,
                selectcontacttel: false,
                piece: '',
                couleur: '',
                surface: '',
                angle: '',
                perimetre: '',
                contenu: ''
              }
              $this.validform = true
              $this.loadingstatus = false
            })
          })
        })
    }
  }
}
</script>

<style lang="scss">
</style>
